<template>
    <div class='rule-dialog dialog-bg'>
        <div class="rule-content">
            <div class="rule-title">活动规则</div>
            <div class="rule-main-wrap">
                <p class="rule-text big-rule"> • 积分邀请任务玩法</p>
                <p class="rule-text">1.邀请人分享口令邀请好友助力，被邀请人通过复制口令，打开芒果TV进入积分页面，即可获得对应积分。</p>
                <p class="rule-text">2.每日最多可邀请5位好友参与，如果被邀请人为芒果TV新用户，则邀请人可获得大额积分。</p>
                <p class="rule-text">3.邀请好友所获得的奖励分值以任务栏显示分值为准噢。</p>
                <p class="rule-text big-rule"> • 活动声明</p>
                <p class="rule-text">
                    1.参与活动的用户若存在任何违规行为(包括但不限于通过爬虫软件、辅助类工具软件、改机工具等作弊软件和不正当手段访问网站、攻击系统、注册账号、登录账号、参与任务、达成交易)，及历史违规账号或通过模型和技术分析得出的风险账号，芒果TV将有权终止其参与活动的资格，处罚方式包括但不仅限于该账号积分清零、撤销积分商品订单等。
                </p>
                <p class="rule-text">
                    2.禁止使用虚拟运营商手机号、运营商手机小号注册或绑定帐号等扰乱平台交易秩序、交易规则的行为。因近期出现大量刷机行为，为保证活动公平，系统将限制号段为162、165、167、170、171的手机号参与活动（包括参与活动和帮助他人助力，将被认定为无效），请使用其他手机号码参与活动，感谢您的理解。
                </p>
                <p class="rule-text">3.用户曾经存在、出现或经芒果TV证实存在违背诚实信用原则的行为，用户将可能面临无法获得奖品的情况，具体如下：</p>
                <p class="rule-text"> •
                    同一用户注册、持有、使用或控制多个芒果TV账户。其中，同一用户指的是同一手机号、身份证号、芒果TV账户、终端设备等与用户身份相关的信息，其中任意一项或者多项存在相同、相似或非真实有效等情况的。</p>
                <p class="rule-text"> • 对本活动如有疑问，您可进入芒果TV-APP-我的-帮助与客服。</p>
                <p class="rule-text"> • 本活动由芒果TV主办，与Apple Inc.苹果公司无关。</p>
            </div>
            <div class="close" @click="$emit('close')"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'rule-dialog',
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() { },
    methods: {
    },
}
</script>
<style scoped lang='less'>
.rule-content {
    width: 570px;
    height: 800px;
    background-color: #fff;
    border-radius: 20px;
    position: relative;

    .rule-main-wrap {
        height: 600px;
        overflow: auto;
    }

    .rule-title {
        height: 137px;
        background-image: url('../../assets/rule-top.png');
        background-size: 100% 100%;
        font-size: 42px;
        text-align: center;
        padding-top: 40px;
        font-weight: bold;
        margin-bottom: 30px;
    }

    .rule-text {
        padding: 0 30px 10px;
        font-size: 28px;
        font-weight: 400;
        color: #666666;
        line-height: 46px;

        &.big-rule {
            font-size: 32px;
            font-weight: 600;
            margin: 30px 0;
        }
    }

}
</style>
